import { ApiStatus } from "@Src/constants";

export const setLoadingState = (api) => {
  api.status = ApiStatus.LOADING;
  api.error = null;
  api.statusText = null;
};

export const setSuccessState = (api, data) => {
  api.status = ApiStatus.SUCCESS;
  api.error = null;
  api.statusText = null;
  return data;
};

export const setFailureState = (api, error, statusText) => {
  api.status = ApiStatus.FAILURE;
  api.error = error;
  api.statusText = statusText;
};

export const initialApiState = {
  status: null,
  error: null,
  statusText: null,
};
